import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaHastaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='FECHA HASTA' htmlFor='filtro-fechaHasta-comprobantesElectronicos' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='fechaHasta'>
          {({ field }) => (
            <Form.InputDate {...field} id='filtro-fechaHasta-comprobantesElectronicos' isInvalid={iTouched && iError} disabled={fIsSubmitting} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaHastaFormGroup)
